import styled from 'styled-components'
import { weight } from '../../../const/fonts'
import { H3 } from '../../../typography'

export const PackageWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  border-radius: 4px;
  background: ${({ theme }) => theme?.appBackground};
`

export const Container = styled.div`
  width: 100%;
  max-width: 80%;
  margin: auto;
  background: ${({ theme }) => theme?.login?.background};
  @media (min-width: 769px) {
    width: 60%;
  }
`
export const Title = styled(H3)`
  text-align: center;
  font-weight: ${weight.bold};
`
